(function () {
    var input = document.getElementById('site-search-input');
    var dropdown = document.getElementById('search-dropdown');
    var searchBtn = document.getElementById('site-search-btn');
    if (!input || !dropdown) return;

    var debounceTimer = null;
    var autocompleteData = null;
    var popularData = null;
    var lastSearchId = 0;

    // Redirect certain search terms to specific pages
    var searchRedirects = [
        { pattern: /\bmemberships?\b/i, url: '/join-and-support/membership/', label: 'Looking for memberships?' },
        { pattern: /\bvenue\s*hire\b/i, url: '/venue-hire', label: 'Looking for venue hire?' },
        { pattern: /\baccess(ibility)?\b/i, url: '/visit/access', label: 'Looking for access information?' },
        { pattern: /\bcontact(\s*us)?\b/i, url: '/contact', label: 'Looking to contact us?' },
        { pattern: /\bseating\s*plan\b/i, url: '/visit/seating-plan', label: 'Looking for the seating plan?' },
        { pattern: /\bgift\s*vouchers?\b/i, url: '/your-visit/gift-vouchers', label: 'Looking for gift vouchers?' },
        { pattern: /\bbrochure\b/i, url: '/brochure', label: 'Looking for the brochure?' },
        { pattern: /\bcareers?\b|\bjobs?\b/i, url: '/careers', label: 'Looking for careers?' }
    ];

    function checkRedirect(query) {
        for (var i = 0; i < searchRedirects.length; i++) {
            if (searchRedirects[i].pattern.test(query)) return searchRedirects[i];
        }
        return null;
    }

    function escapeHtml(str) {
        var d = document.createElement('div');
        d.textContent = str || '';
        return d.innerHTML;
    }

    function getHistory() {
        try {
            var h = JSON.parse(localStorage.getItem('ct_event_history') || '[]');
            return h.slice(0, 10).join(',');
        } catch (e) { return ''; }
    }

    // --- Spelling correction: lightweight Levenshtein distance ---
    function editDistance(a, b) {
        if (a.length === 0) return b.length;
        if (b.length === 0) return a.length;
        var matrix = [];
        for (var i = 0; i <= b.length; i++) matrix[i] = [i];
        for (var j = 0; j <= a.length; j++) matrix[0][j] = j;
        for (var i = 1; i <= b.length; i++) {
            for (var j = 1; j <= a.length; j++) {
                if (b.charAt(i - 1) === a.charAt(j - 1)) {
                    matrix[i][j] = matrix[i - 1][j - 1];
                } else {
                    matrix[i][j] = Math.min(
                        matrix[i - 1][j - 1] + 1,
                        matrix[i][j - 1] + 1,
                        matrix[i - 1][j] + 1
                    );
                }
            }
        }
        return matrix[b.length][a.length];
    }

    // Known terms for spelling correction (built from autocomplete + categories)
    var knownTerms = null;
    function buildKnownTerms() {
        if (knownTerms || !autocompleteData) return;
        var terms = new Set();
        autocompleteData.forEach(function (item) {
            // Add individual words from event names
            item.name.toLowerCase().split(/\s+/).forEach(function (w) {
                if (w.length >= 3) terms.add(w);
            });
        });
        // Add common category/genre terms
        ['comedy', 'music', 'drama', 'family', 'dance', 'musicals', 'pantomime',
         'talks', 'cinema', 'opera', 'ballet', 'theatre', 'concert', 'christmas',
         'children', 'accessible', 'captioned', 'relaxed', 'signed'].forEach(function (t) {
            terms.add(t);
        });
        knownTerms = Array.from(terms);
    }

    function suggestCorrection(query) {
        if (!knownTerms) buildKnownTerms();
        if (!knownTerms || !query) return null;
        var words = query.toLowerCase().split(/\s+/);
        var corrected = [];
        var hasFix = false;
        words.forEach(function (word) {
            if (word.length < 3) { corrected.push(word); return; }
            // Check if word exists in known terms (exact or substring)
            var exactMatch = knownTerms.some(function (t) { return t === word || t.indexOf(word) === 0; });
            if (exactMatch) { corrected.push(word); return; }
            // Find closest match by edit distance
            var bestTerm = null;
            var bestDist = Infinity;
            var maxDist = Math.max(1, Math.floor(word.length / 3)); // Allow ~1 error per 3 chars
            knownTerms.forEach(function (term) {
                if (Math.abs(term.length - word.length) > maxDist) return; // Quick length filter
                var dist = editDistance(word, term);
                if (dist < bestDist && dist <= maxDist) {
                    bestDist = dist;
                    bestTerm = term;
                }
            });
            if (bestTerm && bestDist > 0) {
                corrected.push(bestTerm);
                hasFix = true;
            } else {
                corrected.push(word);
            }
        });
        return hasFix ? corrected.join(' ') : null;
    }

    // --- Autocomplete: prefetch event names ---
    function loadAutocomplete() {
        if (autocompleteData) return;
        fetch('/events/autocomplete')
            .then(function (res) { return res.json(); })
            .then(function (data) { autocompleteData = data; })
            .catch(function () { autocompleteData = []; });
    }

    function filterAutocomplete(query) {
        if (!autocompleteData || !query || query.length < 2) return [];
        var q = query.toLowerCase();
        var qWords = q.split(/\s+/).filter(function(w) { return w.length >= 2; });

        // Substring matches, ranked by name relevance
        var matches = [];
        autocompleteData.forEach(function (item) {
            var name = item.name.toLowerCase();
            var nameStripped = name.replace(/\s+\d{4}$/, '').trim();
            var rank;
            if (nameStripped === q || name === q)
                rank = 0; // exact
            else if (nameStripped.indexOf(q) === 0 || name.indexOf(q) === 0)
                rank = 1; // starts with
            else if (name.indexOf(q) !== -1)
                rank = 2; // contains phrase
            else if (qWords.length > 1 && qWords.every(function(w) { return name.indexOf(w) !== -1; }))
                rank = 3; // all words
            else if (qWords.some(function(w) { return name.indexOf(w) !== -1; }))
                rank = 4; // some words
            else
                return; // no match
            matches.push({ item: item, rank: rank });
        });
        matches.sort(function(a, b) { return a.rank - b.rank || a.item.name.localeCompare(b.item.name); });
        var results = matches.slice(0, 5).map(function(m) { return m.item; });
        if (results.length > 0) return results;

        // Second: fuzzy match — find events where any word is close to any query word
        if (q.length >= 3) {
            var queryWords = q.split(/\s+/).filter(function (w) { return w.length >= 3; });
            var scored = [];
            autocompleteData.forEach(function (item) {
                var nameWords = item.name.toLowerCase().split(/\s+/);
                var bestDist = Infinity;
                queryWords.forEach(function (qw) {
                    nameWords.forEach(function (nw) {
                        if (nw.length < 3) return;
                        // Check if query word is a prefix
                        if (nw.indexOf(qw) === 0) { bestDist = 0; return; }
                        var maxD = Math.max(1, Math.floor(Math.min(qw.length, nw.length) / 3));
                        if (Math.abs(nw.length - qw.length) > maxD) return;
                        var d = editDistance(qw, nw);
                        if (d <= maxD && d < bestDist) bestDist = d;
                    });
                });
                if (bestDist < Infinity) scored.push({ item: item, dist: bestDist });
            });
            scored.sort(function (a, b) { return a.dist - b.dist; });
            return scored.slice(0, 5).map(function (s) { return s.item; });
        }

        return [];
    }

    function renderAutocomplete(matches, query) {
        if (matches.length === 0) return '';
        var q = query.toLowerCase();
        var html = '<div class="site-search__section-label">Suggestions</div>';
        matches.forEach(function (item) {
            var name = escapeHtml(item.name);
            // Bold the matching portion
            var idx = name.toLowerCase().indexOf(q);
            if (idx !== -1) {
                name = name.substring(0, idx) +
                    '<strong>' + name.substring(idx, idx + query.length) + '</strong>' +
                    name.substring(idx + query.length);
            }
            html += '<a class="site-search__result site-search__result--autocomplete" href="/events/' +
                escapeHtml(item.slug) + '" data-search-url="/events/' + escapeHtml(item.slug) + '">' +
                (item.imageUrl
                    ? '<img class="site-search__result-image" src="' + escapeHtml(item.imageUrl) + '" alt="" loading="lazy" />'
                    : '<div class="site-search__result-placeholder"><i class="fa-solid fa-magnifying-glass"></i></div>') +
                '<div class="site-search__result-text"><h4>' + name + '</h4></div></a>';
        });
        return html;
    }

    // --- Popular searches ---
    function loadPopular() {
        if (popularData) return Promise.resolve(popularData);
        return fetch('/events/popular-searches')
            .then(function (res) { return res.json(); })
            .then(function (data) { popularData = data; return data; })
            .catch(function () { popularData = []; return []; });
    }

    function showPopular() {
        loadPopular().then(function (data) {
            if (!data || data.length === 0 || input.value.trim().length > 0) return;
            var html = '<div class="site-search__popular">' +
                '<span class="site-search__popular-label">Popular searches</span>' +
                '<div class="site-search__popular-items">';
            data.forEach(function (item) {
                html += '<button type="button" class="site-search__popular-item" data-term="' +
                    escapeHtml(item.term) + '">' + escapeHtml(item.term) + '</button>';
            });
            html += '</div></div>';
            dropdown.innerHTML = html;
            dropdown.classList.add('active');

            // Bind click handlers
            dropdown.querySelectorAll('.site-search__popular-item').forEach(function (btn) {
                btn.addEventListener('click', function () {
                    input.value = btn.getAttribute('data-term');
                    input.dispatchEvent(new Event('input'));
                });
            });
        });
    }

    // --- Click tracking ---
    function trackClick(url) {
        if (!lastSearchId || !url) return;
        try {
            navigator.sendBeacon('/events/search-click',
                new Blob([JSON.stringify({ searchId: lastSearchId, clickedUrl: url })],
                    { type: 'application/json' }));
        } catch (e) { /* silently fail */ }
    }

    // --- No results with suggestions ---
    function renderNoResults(query, suggestions) {
        var correction = suggestCorrection(query);
        var html = '<div class="site-search__no-results">' +
            '<i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>' +
            '<p>No results found for "<strong>' + escapeHtml(query) + '</strong>"</p></div>';

        if (correction) {
            html += '<div class="site-search__did-you-mean">' +
                'Did you mean <button type="button" class="site-search__correction" data-correction="' +
                escapeHtml(correction) + '">' + escapeHtml(correction) + '</button>?</div>';
        }

        if (suggestions) {
            if (suggestions.categories && suggestions.categories.length > 0) {
                html += '<div class="site-search__suggestions">' +
                    '<span class="site-search__section-label">Browse by category</span>' +
                    '<div class="site-search__category-links">';
                suggestions.categories.forEach(function (cat) {
                    html += '<a href="/events/' + escapeHtml(cat.slug) +
                        '" class="site-search__category-link">' + escapeHtml(cat.name) + '</a>';
                });
                html += '</div></div>';
            }

            if (suggestions.upcoming && suggestions.upcoming.length > 0) {
                html += '<div class="site-search__section-label">Coming up soon</div>';
                suggestions.upcoming.forEach(function (evt) {
                    html += '<a class="site-search__result" href="' + escapeHtml(evt.url) + '">' +
                        (evt.imageUrl
                            ? '<img class="site-search__result-image" src="' + escapeHtml(evt.imageUrl) + '" alt="" loading="lazy" />'
                            : '<div class="site-search__result-placeholder"></div>') +
                        '<div class="site-search__result-text">' +
                        '<h4>' + escapeHtml(evt.name) + '</h4>' +
                        '<p>' + escapeHtml(evt.dateRange || '') + '</p>' +
                        '</div></a>';
                });
            }
        }

        return html;
    }

    // --- Main search ---
    function doSearch(query) {
        if (!query || query.length < 2) {
            dropdown.classList.remove('active');
            return;
        }

        // Show instant autocomplete while full search loads
        var autoMatches = filterAutocomplete(query);
        if (autoMatches.length > 0) {
            dropdown.innerHTML = renderAutocomplete(autoMatches, query);
            dropdown.classList.add('active');
        }

        // Show page redirect suggestion above results
        var redirect = checkRedirect(query);
        var redirectHtml = redirect
            ? '<a class="site-search__result site-search__result--page" href="' + redirect.url + '" data-search-url="' + redirect.url + '">' +
              '<div class="site-search__result-placeholder"><i class="fa-solid fa-arrow-right"></i></div>' +
              '<div class="site-search__result-text"><h4>' + escapeHtml(redirect.label) + '</h4>' +
              '<p>Take me there &rarr;</p></div></a>'
            : '';

        var eventUrl = '/events/search?q=' + encodeURIComponent(query) + '&limit=6';
        var hist = getHistory();
        if (hist) eventUrl += '&history=' + encodeURIComponent(hist);

        var siteUrl = '/api/site-search?q=' + encodeURIComponent(query) + '&limit=4';

        Promise.all([
            fetch(eventUrl).then(function (res) { return res.json(); }).catch(function () { return { results: [] }; }),
            fetch(siteUrl).then(function (res) { return res.json(); }).catch(function () { return { results: [] }; })
        ]).then(function (responses) {
            var eventData = responses[0];
            var siteData = responses[1];
            var eventResults = eventData.results || [];
            var siteResults = siteData.results || [];
            var pills = eventData.pills || [];
            var isFuzzy = eventData.fuzzy === true;
            lastSearchId = eventData.searchId || 0;
            var html = '';

            // Show insight pills if intent was parsed
            if (pills.length > 0) {
                html += '<div class="site-search__pills">';
                pills.forEach(function (pill) {
                    html += '<span class="site-search__pill site-search__pill--' +
                        escapeHtml(pill.type) + '">' + escapeHtml(pill.label) + '</span>';
                });
                html += '</div>';
            }

            // Prepend page redirect if matched
            html = redirectHtml + html;

            if (eventResults.length === 0 && siteResults.length === 0 && !redirect) {
                html += renderNoResults(query, eventData.suggestions);
                dropdown.innerHTML = html;
                dropdown.classList.add('active');
                bindClickTracking();
                return;
            }

            // Show fuzzy match notice with spelling correction
            if (isFuzzy && eventResults.length > 0) {
                var correction = suggestCorrection(query);
                if (correction) {
                    html += '<div class="site-search__did-you-mean">' +
                        'Did you mean <button type="button" class="site-search__correction" data-correction="' +
                        escapeHtml(correction) + '">' + escapeHtml(correction) + '</button>?</div>';
                } else {
                    html += '<div class="site-search__fuzzy-notice">Showing closest matches</div>';
                }
            }

            // Event results
            if (eventResults.length > 0) {
                html += '<div class="site-search__section-label">Events</div>';
                eventResults.forEach(function (evt) {
                    html += '<a class="site-search__result" href="' + escapeHtml(evt.url) + '" data-search-url="' + escapeHtml(evt.url) + '">' +
                        (evt.imageUrl
                            ? '<img class="site-search__result-image" src="' + escapeHtml(evt.imageUrl) + '" alt="" loading="lazy" />'
                            : '<div class="site-search__result-placeholder"></div>') +
                        '<div class="site-search__result-text">' +
                            '<h4>' + escapeHtml(evt.name) + '</h4>' +
                            '<p>' + escapeHtml(evt.dateRange || '') +
                            (evt.genre ? ' &middot; ' + escapeHtml(evt.genre) : '') + '</p>' +
                        '</div></a>';
                });
            }

            // Site content results
            if (siteResults.length > 0) {
                html += '<div class="site-search__section-label">Pages</div>';
                siteResults.forEach(function (page) {
                    html += '<a class="site-search__result" href="' + escapeHtml(page.url) + '" data-search-url="' + escapeHtml(page.url) + '">' +
                        (page.imageUrl
                            ? '<img class="site-search__result-image" src="' + escapeHtml(page.imageUrl) + '" alt="" loading="lazy" />'
                            : '<div class="site-search__result-placeholder"><i class="fa-solid fa-file-lines"></i></div>') +
                        '<div class="site-search__result-text">' +
                            '<h4>' + escapeHtml(page.name) + '</h4>' +
                        '</div></a>';
                });
            }

            html += '<a class="site-search__more" href="/events?q=' + encodeURIComponent(query) + '">See all results &rarr;</a>';
            dropdown.innerHTML = html;
            dropdown.classList.add('active');
            bindClickTracking();
        }).catch(function () {
            if (redirect) {
                dropdown.innerHTML = redirectHtml;
                dropdown.classList.add('active');
            } else {
                dropdown.classList.remove('active');
            }
        });
    }

    // Bind click tracking and "did you mean" correction clicks
    function bindClickTracking() {
        dropdown.querySelectorAll('[data-search-url]').forEach(function (link) {
            link.addEventListener('click', function () {
                trackClick(link.getAttribute('data-search-url'));
            });
        });
        dropdown.querySelectorAll('.site-search__correction').forEach(function (btn) {
            btn.addEventListener('click', function () {
                input.value = btn.getAttribute('data-correction');
                doSearch(input.value.trim());
            });
        });
    }

    // --- Event listeners ---
    input.addEventListener('focus', function () {
        loadAutocomplete();
        if (input.value.trim().length === 0) {
            showPopular();
        }
    });

    input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        var q = input.value.trim();

        if (q.length === 0) {
            showPopular();
            return;
        }

        // Show instant autocomplete
        var autoMatches = filterAutocomplete(q);
        if (autoMatches.length > 0) {
            dropdown.innerHTML = renderAutocomplete(autoMatches, q);
            dropdown.classList.add('active');
        }

        debounceTimer = setTimeout(function () { doSearch(q); }, 300);
    });

    input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            var q = input.value.trim();
            if (q) {
                var r = checkRedirect(q);
                window.location.href = r ? r.url : '/events?q=' + encodeURIComponent(q);
            }
        }
        if (e.key === 'Escape') {
            dropdown.classList.remove('active');
        }
    });

    if (searchBtn) {
        searchBtn.addEventListener('click', function () {
            var q = input.value.trim();
            if (q) {
                var r = checkRedirect(q);
                window.location.href = r ? r.url : '/events?q=' + encodeURIComponent(q);
            }
        });
    }

    document.addEventListener('click', function (e) {
        if (!e.target.closest('.site-search')) {
            dropdown.classList.remove('active');
        }
    });
})();
